exports.textTileTemplate = {
    $type: "TextTile",
    style: {
        title: {
            show: true,
        },
    },
};
